module.exports = "<div class=\"mat-app-background basic-container\">\n  <app-navigation-bar></app-navigation-bar>\n\n  </div>\n"